import { numConvert, calculation, sum } from "../../../../method";
import moment from "moment";

export default function (data, date) {
    const month = moment(date).daysInMonth();
    const totalIndex = [0, 3, 14, 25];

    data.forEach((item, index) => {
        if (![...totalIndex, 46].includes(index)) {
            data[index].space = (numConvert(data[index].meet) * month).toFixed(2);
        }
    });

    // total
    const totalName = ['meet', 'space', 'no', 'sold', 'total'];

    totalName.forEach(name => {
        totalIndex.forEach((index, i) => {
            data[index][name] = data.reduce((a, b, j) => {
                if (totalIndex[i + 1] >= 0 && j > index && j < totalIndex[i + 1]) {
                    a += numConvert(b[name]);
                }
                if (!totalIndex[i + 1] && j > index && j <= 45) {
                    a += numConvert(b[name]);
                }
                return a;
            }, 0).toFixed(2);
        });
        data[46][name] = totalIndex.reduce((a, b) => {
            a += numConvert(data[b][name]);
            return a
        }, 0).toFixed(2);
    });

    // 宴会收入、平均收入
    data.forEach((item, i) => {
        data[i].sc = calculation(item.total, item.sold, 2);
        data[i].rev = calculation(item.total, item.space, 2);
        if (!totalIndex.includes(i)) {
            data[i].occ = calculation(
                item.no,
                sum([...totalIndex.map(x => data[x].no)]),
                4
            );
        }
    });

    data[0].occ = sum([data[1].occ, data[2].occ], 4);
    data[3].occ = data.reduce((a, b, i) => {
        if (i > 3 && i < 14) {
            a += numConvert(b.occ);
        }
        return a
    }, 0).toFixed(4);
    data[14].occ = data.reduce((a, b, i) => {
        if (i > 14 && i < 25) {
            a += numConvert(b.occ);
        }
        return a
    }, 0).toFixed(4);
    data[25].occ = data.reduce((a, b, i) => {
        if (i > 25 && i < 46) {
            a += numConvert(b.occ);
        }
        return a
    }, 0).toFixed(4);
    return data;
}


// WEBPACK FOOTER //
// ./src/components/table/6.0/6-2/compute.js